<template>
  <div class="container">
    <h1 class="logo-stormgroup rpl" v-scroll-to="'body'" id="element">
      <router-link :to="{ name: 'home' }">StormGroup</router-link>
    </h1>
    <SwitchLocale v-model="$i18n.locale" />
  </div>
</template>

<script>
import Vue from "vue";
import SwitchLocale from "./SwitchLocale.vue";
let VueScrollTo = require("vue-scrollto");

Vue.use(VueScrollTo);

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

export default {
  components: {
    SwitchLocale,
  },
  props: [""],
};
</script>

<style lang="scss">
#Header {
  height: 100px;
  background-color: #222831;
  position: fixed;
  width: 100%;
  z-index: 100;
  top: 0;

  .container {
  }
  .logo-stormgroup {
    width: 204px;
    height: 24px;
    position: absolute;
    top: 39px;
    left: 100px;
    z-index: 99;
  }
}

@media (max-width: 768px) {
  body {
    padding-top: 70px;
  }

  #Header {
    height: 70px;
    .logo-stormgroup {
      width: 130px;
      height: 20px;
      position: absolute;

      top: 27px;
      left: 50%;
      margin-left: calc(130px / 2 * -1);
      z-index: 99;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Header.vue